export default __webpack_public_path__ + "static/media/group-5.af8b400b.png";